<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
       />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <filter-manager
          :display-advanced="false"
          class="search-bar"
          items-container-class="flex-wrap"
          search-icon="fa fa-sync"
          search-text="Procesar"
          search-container-class="btn-process"
          v-model="model.search.filters"
          :filters="filterManagerConfig"
          @search="onHandlerSearch"
          ref="filterRef"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader'
import FilterManager from 'FilterManager'
import AcademicYearServices from '@/services/api/academicyear.api'
import ProviderServices from '@/services/api/provider.api'
import ReportServices from '@/modules/report/api'
import DocumentServices from '@/modules/report/document'

export default {
  components: {
    PageHeader,
    FilterManager,
  },
  data: () => 
  ({
    page: {
      icon: 'fas fa-clipboard-list-check',
      title: 'Licencias y Disciplinas de Especialistas',
      routes: ["Informes", "Licencias y Disciplinas de Especialistas"]
    },
    model: {
      search: {
        collections: {
          academicYears: [],
          providers:[]
        },
        filters: {
          academicYear: null,
          provider:null
        },
      },
    },
  }),
  computed: {
    filterManagerConfig() {
    return [
      {
        name: 'academicYear',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'description',
        label: 'Año Académico',
        placeholder: 'Seleccionar',
        error: "Favor seleccionar un año académico.",
        validations: "required",
        clearable: false,
        options: this.model.search.collections.academicYears,
        value: this.model.search.filters.academicYear,
        onChanged:this.onAcademicYearSelected
      },
      {
        name: 'provider',
        component: 'custom-drop-down',
        fieldKey: 'id',
        fieldName: 'name',
        label: 'Proveedor',
        placeholder: 'Seleccionar',
        validations: "",
        clearable: false,
        options: this.model.search.collections.providers,
        value: this.model.search.filters.provider,
        disabled: this.model.search.collections.providers.length <= 0 || this.model.search.collections.providers.length == 1,
      }
    ]
    },
  },
  async mounted() {
    await this.setFilters();
  },
  methods: {
    async setFilters() {
      await AcademicYearServices.getCurrentYearAcademicYears()
        .then(res => this.model.search.collections.academicYears = res.data);  
    },
    async onAcademicYearSelected(){
      await ProviderServices.getAllProvidertCompaniesByYear({AcademicYearId: this.model.search.filters.academicYear?.id})
        .then(res => {
          this.model.search.collections.providers = res.data

          if(res.data.length == 1) {
            this.model.search.filters.provider = res.data[0];
          }
        });
    },
    async onHandlerSearch() {
      this.process();
    },
    async process() {
      if( !!this.model.search.filters.academicYear
          && !!this.model.search.filters.provider)
         {
            await ReportServices.getReport('reportspecialistlicenses', {
            academicYearId:  this.model.search.filters.academicYear.id,
            companyId: this.model.search.filters.provider.id
            })
            .then(res => DocumentServices.Download(res.data));
         }
    },
  },
}
</script>